<template>
  <div class="amount-block normal" :class="size">
    <div class="inner" :class="{ bad: is_bad }">
      <div class="label-minus" v-on:click="minus()"><icon scale="1.8" name="minus"></icon></div>
      <label style="height: 100%;width: 100%;float: left;"><input autocomplete="off" :value="fvalue" v-on:change="$emit('input', $event.target.value)" v-on:input="$emit('input', $event.target.value)" :type="suffix ? 'text' : 'number'" :name="name" :step="step" :min="min" :max="max" style="text-align: center;"/></label>
      <div class="label-plus" v-on:click="plus()"><icon scale="1.8" name="plus"></icon></div>
    </div>
    <p>{{ is_bad ? $t('messages.order.random_message', { number : (parseInt(value) + parseInt(value / 100 * this.$parent.random * 2)) }) : label }}</p>
  </div>
</template>

<script>
export default {
  name: 'Number',
  props: {
    name : {
      type: String,
      required: true,
    },
    label : {
      type: String,
      required: true,
    },
    suffix: {
      type: String,
      required: false,
      default: ''
    },
    size : {
      type: String,
      required: false,
      default: 'block half'
    },
    value: {
      type: Number,
      required: false,
      default: function () {
        return 0
      }
    },
    default: {
      type: Number,
      required: false,
      default: function () {
        return 0
      }
    },
    step: {
      type: Number,
      required: false,
      default: function () {
        return this.$parent.service.step
      }
    },
    min: {
      type: Number,
      required: false,
      default: function () {
        return this.$parent.service.min
      }
    },
    max: {
      type: Number,
      required: false,
      default: function () {
        return this.$parent.service.max
      }
    },
    random: {
      type: Boolean,
      required: false,
      default: function () {
        return true
      }
    },
    optional: {
      type: Boolean,
      required: false,
    },
  },
  data: function () {
    return {
      event : null,
    }
  },
  computed: {
    is_bad: function () {
      return this.random && this.$parent.random && this.value && this.min > (this.value - this.value / 100 * this.$parent.random)
    },
    fvalue: function () {
      return this.value + (this.suffix ? this.suffix : 0)
    },
    plusstep: function () {
      return (this.step === 1 ? 100 : this.step);
    }
  },
  created: function(){

  },
  methods: {
    plus: function () {
      if(this.value + this.plusstep <= this.max)
      {
        if(this.value < this.plusstep)
        {
          this.$emit('input', this.plusstep);
        }
        else
        {
          this.$emit('input', this.value + this.plusstep);
        }
      }
    },
    minus: function () {
      var min = this.optional ? 0 : this.min;

      if(this.value - this.plusstep >= min)
      {
        this.$emit('input', this.value - this.plusstep);
      }
      else if(this.value - this.plusstep >= 0)
      {
        this.$emit('input', min);
      }
    },
  },
  watch: {
    value: function(value, prev) {
      var min = this.optional && value === 0 ? 0 : this.min;
      var val = isNaN(value) ? 0 : Math.round(value / this.step) * this.step;
      var filter = Math.max(Math.min(val, this.max), min);

      if(val !== prev)
      {
        clearTimeout(this.event);
        var self = this;
        this.event = setTimeout(function () {
          self.$emit('input', filter);
        }, 1000);
      }
    },
  },
}
</script>

<style scoped>

</style>